<template>
  <div>
    <v-row no-gutters>
      <v-col sm="8" class="pa-0">
        <h2>Virus Settings</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <VirusState
          :preferenceId="$preference.VIRUS_INCOMING_SETTINGS"
          :preferenceText="'Incoming'"
          :preferenceKey="'incomingSettings'"
        />
        <VirusState
          :preferenceId="$preference.VIRUS_OUTGOING_SETTINGS"
          :preferenceText="'Outgoing'"
          :preferenceKey="'outgoingSettings'"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import VirusState from '@/components/SysSettings/VirusSetting/VirusState';
export default {
  components: {
    VirusState
  },
  data() {
    return {
      checkboxOA: false,
      checkboxO: false,
      searchItemO: ''
    };
  },
  props: ['title'],
  methods: {
    savesetting() {},
    cancel() {}
  }
};
</script>

<style></style>
